import { IconButton } from '../IconButton/IconButton';
import type { IZoomSteps, ZoomStep } from './useZoomSteps';
import styles from './ZoomButtons.module.css';

interface IZoomButtonsProps {
  zoom: IZoomSteps;
  zoomOutLabel: string;
  zoomInLabel: string;
}

/** A map's − / + pair over `useZoomSteps`; the caller's toolbar lays them out. */
export function ZoomButtons({ zoom, zoomOutLabel, zoomInLabel }: IZoomButtonsProps) {
  return (
    <>
      <ZoomButton label={zoomOutLabel} glyph="−" target={zoom.smaller} onZoom={zoom.setZoom} />
      <ZoomButton label={zoomInLabel} glyph="+" target={zoom.larger} onZoom={zoom.setZoom} />
    </>
  );
}

interface IZoomButtonProps {
  label: string;
  glyph: string;
  /** The step it moves to; undefined at the end of the range. */
  target: ZoomStep | undefined;
  onZoom(step: ZoomStep): void;
}

function ZoomButton({ label, glyph, target, onZoom }: IZoomButtonProps) {
  return (
    <IconButton
      aria-label={label}
      disabled={target === undefined}
      onClick={target === undefined ? undefined : () => onZoom(target)}
    >
      <span aria-hidden className={styles.glyph}>
        {glyph}
      </span>
    </IconButton>
  );
}
